import { PeriodPreset, PeriodQuickFilter } from 'components/tables/list-table/ListTableTypes';
import { t } from 'utils/getTranslations';

/** The selector every report reads its date range from, both ends inclusive. */
export const PERIOD_SELECTOR = 'period';

/** The periods a report's period chip offers, in the dashboard's order. Each spans whole calendar months. */
export type ReportPeriod = 'current-month' | 'last-month' | 'current-year' | 'last-year';

export const REPORT_PERIODS: ReportPeriod[] = ['current-month', 'last-month', 'current-year', 'last-year'];

export function reportPeriodRange(period: ReportPeriod, today: Date): { from: Date; to: Date } {
    const year = today.getFullYear();
    const month = today.getMonth();
    const [from, to] = {
        'current-month': [new Date(year, month, 1), new Date(year, month + 1, 0)],
        'last-month': [new Date(year, month - 1, 1), new Date(year, month, 0)],
        'current-year': [new Date(year, 0, 1), new Date(year, 11, 31)],
        'last-year': [new Date(year - 1, 0, 1), new Date(year - 1, 11, 31)],
    }[period];
    return { from, to };
}

/** The report's month chip in the quick filter bar, onto its `period` filter, opening on the current month. */
export function monthQuickFilter(): PeriodQuickFilter {
    return { ...periodQuickFilter({ periods: ['current-month'], defaultPeriod: 'current-month' }), month: true };
}

/**
 * The report's period chip in the quick filter bar, onto its `period` filter.
 *
 * @param defaultPeriod the period the report opens with, as its Superset dashboard does; the list fills it in
 *        whenever the filters hold no period, remembered or cleared ones too
 */
export function periodQuickFilter({
    periods = REPORT_PERIODS,
    defaultPeriod,
}: { periods?: ReportPeriod[]; defaultPeriod?: ReportPeriod } = {}): PeriodQuickFilter {
    const presets = periods.map(
        (period): PeriodPreset => ({
            value: period,
            label: t(`time.${period}`),
            range: (today) => reportPeriodRange(period, today),
        })
    );
    return { selector: PERIOD_SELECTOR, presets, defaultPreset: defaultPeriod };
}
